import React from 'react';
import _omit from 'lodash/omit';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import { getContext } from 'common';
import Typography from 'components/Typography';

const DEFAULT_ERROR_MAX_LINES = 2;

const ERROR_TYPOGRAPHY_CONFIG = color => ({
  role: 'alert',
  maxLines: DEFAULT_ERROR_MAX_LINES,
  style: {
    ...Tokens.TYPOGRAPHY.CAPTION,
    color
  }
});

export interface SelectItemErrorMessageProps extends React.ComponentPropsWithRef<'div'> {
  /** The error message. */
  children: string;
}

/** Any other props than the `SelectItemErrorMessage` props will be provided to the <Typography /> component. */
const SelectItemErrorMessage:React.FC<SelectItemErrorMessageProps> = ((props: SelectItemErrorMessageProps) => getContext(({ theme }) => {
  const typographyProps = _omit({
    ...ERROR_TYPOGRAPHY_CONFIG(theme.TEXT_INPUT.ERROR_MSG),
    ...props
  }, 'children');
  return <Typography {...typographyProps}>{props.children}</Typography>;
}));

SelectItemErrorMessage.displayName = 'SelectItemErrorMessage';

export {
  SelectItemErrorMessage as default,
};